import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ImmutableProptypes from 'react-immutable-proptypes'

import { updateSettings } from '_modules/settings/actions'

import styles from './styles.css'

const mapStateToProps = ({ settings }) => ({
  settings,
})

const mapDispatchToProps = {
  updateSettings,
}

class CircularProgressBar extends PureComponent {
  static propTypes = {
    settings: ImmutableProptypes.map,
    updateSettings: PropTypes.func.isRequired,
    inProgress: PropTypes.bool.isRequired,
    text: PropTypes.string.isRequired,
    onKeyPress: PropTypes.func.isRequired,
  }

  static defaultProps = {
    settings: new Map(),
    sqSize: 250,
    percentage: 0,
    strokeWidth: 1,
  }

  constructor(props) {
    super(props)

    this.state = {
      flexibleTimeInterval: 0,
      timeInput: '',
    }
  }

  componentDidMount() {
    const settings = this.props.settings.toJS()
    this.getState(settings)
  }

  componentWillReceiveProps(nextProps) {
    const settings = nextProps.settings.toJS()
    this.getState(settings)
  }

  onKeyPress = e => {
    if (this.state.timeInput.length === 5) {
      this.props.onKeyPress(e)
    }
  }

  onFieldChange = value => {
    const { timeInput } = this.state
    const { inProgress } = this.props

    if (this.isValid(value)) {
      // if one digit and colon typed, add zero at begining
      if (value.length === 2 && timeInput.length === 1 && value.indexOf(':') !== -1)
        value = '0' + value
      // if both digits of minutes typed, add colon
      if (value.length === 2 && timeInput.length !== 3 && value.indexOf(':') === -1) value += ':'
      // if colon is deleted, delete colon
      if (value.length === 2 && timeInput.length === 3) value = value.slice(0, -1)

      if (value.length > 5) return

      this.setState({ timeInput: value })

      if (value.length === 5 || (value.length === 0 && !inProgress)) {
        this.setState({ timeInput: value }, () => {
          this.props.updateSettings({
            ...this.props.settings.toJS(),
            flexibleTimeInterval: this.getValue(),
          })
        })
      }
    }
  }

  getState = settings => {
    if (this.props.inProgress) {
      this.setState({
        flexibleTime: settings.flexibleTime,
        timeInput: '',
      })
    } else {
      this.setState({
        flexibleTime: settings.flexibleTime,
      })
    }
  }

  getValue = () => {
    const [minutesStr, secondsStr] = this.state.timeInput.split(':')
    return Number(minutesStr) * 60 + Number(secondsStr)
  }

  inputFromMinutes = interval => {
    const totalSeconds = interval * 60

    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    const minuteStr = minutes.toString().padStart(2, '0')
    const secondStr = seconds.toString().padStart(2, '0')

    return `${minuteStr}:${secondStr}`
  }

  inputFromSeconds = interval => {
    const minutes = Math.floor(interval / 60)
    const seconds = interval % 60
    const minuteStr = minutes.toString().padStart(2, '0')
    const secondStr = seconds.toString().padStart(2, '0')

    return `${minuteStr}:${secondStr}`
  }

  isValid = val => {
    // const letterArr = val.split(':').join('').split('')
    const regexp = new RegExp(/^((([0-9][0-9])|[0-9]|)(|:|:[0-5]|:[0-5][0-9]))$/)

    if (!regexp.test(val)) return false

    return true
  }

  render() {
    const { flexibleTime, timeInput } = this.state
    const opacity = timeInput.length === 5 ? 0.8 : 0.3
    // Size of the enclosing square
    const sqSize = this.props.sqSize
    // SVG centers the stroke width on the radius, subtract out so circle fits in square
    const radius = (this.props.sqSize - this.props.strokeWidth) / 2
    // Enclose cicle in a circumscribing square
    const viewBox = `0 0 ${sqSize} ${sqSize}`
    // Arc length at 100% coverage is the circle circumference
    const dashArray = radius * Math.PI * 2
    // Scale 100% coverage overlay with the actual percent
    const dashOffset = dashArray - (dashArray * this.props.percentage) / 100 || 0

    return (
      <div width={this.props.sqSize} height={this.props.sqSize}>
        <svg
          className={styles.circle}
          width={this.props.sqSize}
          height={this.props.sqSize}
          viewBox={viewBox}
        >
          <circle
            className={styles['circle-background']}
            cx={this.props.sqSize / 2}
            cy={this.props.sqSize / 2}
            r={radius}
            strokeWidth={`${this.props.strokeWidth}px`}
          />
          <circle
            className={styles['circle-progress']}
            cx={this.props.sqSize / 2}
            cy={this.props.sqSize / 2}
            r={radius}
            strokeWidth={`${this.props.strokeWidth}px`}
            // Start progress marker at 12 O'Clock
            transform={`rotate(-90 ${this.props.sqSize / 2} ${this.props.sqSize / 2})`}
            style={{
              strokeDasharray: dashArray,
              strokeDashoffset: dashOffset,
            }}
          />
        </svg>
        <div
          className={styles['circle-text']}
          style={{ position: 'relative', width: '100%', top: -this.props.sqSize / 2 }}
        >
          {!this.props.inProgress && flexibleTime ? (
            <input
              ref={this.props.setRef}
              style={{
                fontSize: '40px',
                textAlign: 'center',
                width: '150px',
                marginTop: '-20px',
                opacity: `${opacity}`,
              }}
              onKeyPress={this.onKeyPress}
              type="text"
              name="timeInput"
              value={timeInput}
              placeholder="mm:ss"
              onChange={e => {
                this.onFieldChange(e.target.value)
              }}
            />
          ) : (
            this.props.text || `${this.props.percentage}%`
          )}
        </div>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CircularProgressBar)



// WEBPACK FOOTER //
// ./src/views/circle/index.js